<template>
    <div class="form-group" v-bind:class="{'dark': this.getDesign() == 'black', 'white' : this.getDesign() == 'white' }">
        <input type="text" v-bind:class="{'required-field': field.isRequired}" :placeholder="$t(this.field.name)" v-model="value" :required="field.isRequired" @change="changeInput">
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';

    export default {
        name: "input-normal-dni",
        props: ["field"],
        data() {
            return {
                value: '',
            }
        },
        computed: {
            ...mapGetters(['getDesign','getCheckout'])
        },
        created() {
            this.value = this.getCheckout().dni;
            this.changeInput();
        },
        methods: {
            ...mapMutations(['updateCheckoutField']),
            changeInput: function () {
                this.updateCheckoutField({name: 'dni', value: this.value});
                if(this.getCheckout().id) {
                    this.$emit('change-field');
                }
            }
        }
    }
</script>
